import React from 'react';
import PropTypes from 'prop-types';

import MuiLink from '@material-ui/core/Link';

import { Link } from 'react-router-dom';

const InnerLink = ({ route, label, value, theme }) => {
  const link = props => <Link to={route} {...props} />;
  return (
    <div className={`item ${theme}`}>
      <div className="link">
        <MuiLink
          title={label || value}
          component={React.forwardRef((props, ref) => link(props))}
          key={`inner-link-item-${label}`}
        >
          {label || value}
        </MuiLink>
      </div>
    </div>
  );
};

InnerLink.propTypes = {
  route: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  theme: PropTypes.string,
};
InnerLink.defaultProps = {
  label: undefined,
  theme: 'white',
};

export default InnerLink;
